<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const handleChangePage = (page: number) => {
  // Handle the page change logic here
}

const handleUpdateFilter = (filter: any) => {
  // Handle the filter update logic here
}
</script>

<template>
  <dashboard-layout currentRoute="posts.posts" page-title="Danh sách bài viết">
    <filter-list
      :filter="[
        {
          key: 'title',
          type: 'taginput',
          label: $t('post.filter.item.title'),
          placeholder: $t('post.filter.placeholder.title'),
          value: '',
        },
        {
          key: 'status',
          type: 'select-multiple',
          label: $t('post.filter.item.status'),
          placeholder: $t('post.filter.placeholder.status'),
          value: '',
          options: [
            { label: $t('post.filter.status.all'), value: '' },
            { label: $t('post.filter.status.published'), value: 'published' },
            { label: $t('post.filter.status.draft'), value: 'draft' },
            { label: $t('post.filter.status.pending'), value: 'pending' },
            { label: $t('post.filter.status.trash'), value: 'trash' },
          ],
        },
      ]"
      @update:filter="handleUpdateFilter"
    />
    <data-table
      :buttons="[
        {
          label: $t('post.datatable.buttons.add'),
          icon: 'gridicons:create',
          class: 'btn bg-primary bg-hover-primary text-white',
          action: () => {
            router.push({ name: 'post-create' })
          },
        },
        {
          label: $t('post.datatable.buttons.delete'),
          icon: 'tabler:trash',
          class: 'btn btn-secondary bg-hover-secondary',
          action: () => {},
        },
      ]"
      @page-changed="handleChangePage"
    />
  </dashboard-layout>
</template>

<style scoped></style>
